<div class="painel-principal" style="padding: 10px;" *ngIf="isValidarFormulario">

    <mat-tab-group>

        <!-- DADOS OFICINA -->
        <mat-tab label="OFICINA">
            <div ngModelGroup="grupoCadastroOficina">
                <dados-atividade [atividade]=oficina></dados-atividade>
            </div>
        </mat-tab>

        <mat-tab label="AÇÕES">
            <div ngModelGroup="acoesAtividade">
                <acoes-oficina-turma [oficina]="oficina"
                               [perfilAcesso]="perfilAcesso"></acoes-oficina-turma>
            </div>
        </mat-tab>

        <!-- DADOS COLABORADORES ATIVIDADE -->
        <mat-tab label="COLABORADORES">
            <form #formCadastroColaboradoresAtividade="ngForm">
                <colaboradores-atividade [oficina]="oficina"></colaboradores-atividade>
            </form>
        </mat-tab>

        <!-- MATERIAIS DA ATIVIDADE -->
        <mat-tab label="MATERIAIS">
            <form #formCadastroMateriaisAtividade="ngForm">
                <materiais-oficina [oficina]="oficina"></materiais-oficina>
            </form>
        </mat-tab>

    </mat-tab-group>

</div>

<div dir="rtl" fxLayout="row" fxLayoutAlign="center center"
     fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>

    <button *ngIf="!isAtualizar" mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary"
            (click)="cancelar()">
        Limpar Oficina
    </button>

    <button *ngIf="!isAtualizar" mat-raised-button name="botaoAdicionar" fxFlex="20%" color="primary"
            (click)="adicionar()">
        Adicionar Oficina
    </button>

    <button *ngIf="isAtualizar" mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" 
            (click)="atualizar()">
        Atualizar Oficina
    </button>

</div>
